module.exports = __webpack_public_path__ + "img/digitalized-3.a5c04fc7.png";